import React, { useState } from "react";
import { Controller } from "react-hook-form";
import Stack from "@mui/material/Stack/Stack";
import Typography from "@mui/material/Typography/Typography";
import TextField from "@mui/material/TextField/TextField";
import SelectedCountryCode from "./SelectedCountryCode";
import { ICountry, IFormField } from "models/app";
import { countriesList } from "config";

interface Props extends IFormField {
  errors: any;
  control: any;

  required?: boolean;
  defaultValue?: any;
  setValue?: any;
  watch?: any;
}

const RHPhoneNumber: React.FC<Props> = ({
  label,
  name,
  type,
  placeholder,
  disabled,
  autoFocus,
  control,
  errors,
  required,
  defaultValue,
  onChange,
  watch,
  hidden,
  endAdornment,
  helperText,
  startAdornment,
  multiline,
  minRows,
  showLabel = true,
  subDefaultValue,
}) => {
  let defaultCountry: any = subDefaultValue
    ? countriesList.find(
        (country) =>
          country.countryCode.toLowerCase() === subDefaultValue.toLowerCase()
      )
    : countriesList.find((country) => country.countryCode === "SA");
  const [selectedCountry, setSelectedCountry] = useState<ICountry | null>(
    defaultCountry
  );

  const value = watch(name);

  const handleSelectCountryCode = (value: any) => {
    setSelectedCountry(value);
  };

  return (
    <Stack spacing={1} width={"100%"} mt={0}>
      {label && showLabel && (
        <Typography variant="body2" fontWeight={600} textAlign={"start"} mr={3}>
          {label}
        </Typography>
      )}
      {!hidden && (
        <Stack direction={"row"} spacing={1} width={"100%"}>
          <Stack width={{ base: "50%", lg: "35%" }}>
            <SelectedCountryCode
              selectedCountry={selectedCountry!}
              onChange={(e: any) => {
                onChange && onChange(e.phoneNumberCode + value);
                handleSelectCountryCode(e);
              }}
              disabled={disabled}
            />
          </Stack>
          <Stack width={{ base: "50%", lg: "65%" }}>
            <Controller
              control={control}
              name={name}
              render={({ field }) => (
                <TextField
                  fullWidth
                  size="small"
                  {...field}
                  required={required}
                  type={type}
                  inputProps={{
                    min: type === "number" ? 0 : undefined,
                    icon: null,
                  }}
                  disabled={disabled}
                  autoFocus={autoFocus}
                  placeholder={placeholder}
                  multiline={multiline!}
                  minRows={minRows!}
                  error={!!errors[name]}
                  InputProps={{
                    endAdornment: endAdornment!,
                    startAdornment: startAdornment!,
                  }}
                  InputLabelProps={{
                    children: label,

                    sx: {
                      fontSize: "18px",
                      color: required && !value ? "red" : "text.main",
                      "& .MuiInputLabel-asterisk": {
                        color: required && !value ? "red" : "text.main",
                        fontSize: "24px",
                      },
                    },
                  }}
                  label={label}
                  onChange={(e: any) => {
                    onChange &&
                      onChange(
                        selectedCountry?.phoneNumberCode + e.target.value
                      );
                    field.onChange(e);
                  }}
                  onKeyDown={(e: any) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "common.white",
                    },
                    "& .MuiInputBase-root": {
                      fontFamily: "Cairo",
                      p: "2px",
                      px: "10px",
                      borderRadius: "8px",
                      color: "label.main",
                      border: "none",
                      bgcolor: "#fff",
                      fontSize: "18px",
                      height: "48px",
                    },
                    "& .MuiInputBase-root.Mui-disabled": {
                      bgcolor: "#f5f5f5",
                    },
                    "& .MuiFormLabel-root": {
                      color: !disabled ? "text.main" : "text.disabled",
                    },
                  }}
                />
              )}
            />
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};

export default RHPhoneNumber;
